import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import '@progress/kendo-ui';
declare let kendo: any;
@Component({
  selector: 'ags-kendo-progress-bar',
  templateUrl: './kendo-progress-bar.component.html',
  styleUrls: ['./kendo-progress-bar.component.scss']
})
export class KendoProgressBarComponent implements AfterViewInit {
  @Input() public type: string;
  @Input() public max: number;
  @Input() public min: number;
  @Input() public value: number;
  @Input() public name: string;
  @Input() public chunkCount: number;
  @Input() public height: number;
  @Input() public width: number;
  @Input() public emptyBarColor: string;
  @Input() public progressColor: string;
  @Input() public textBar: string;
  @ViewChild('progressBar') progressBar: ElementRef;
  progressBarStyle = {};

  ngAfterViewInit(): void {
    this.progressBarStyle = {
      height: this.height,
      width: this.width,
      'background-color': this.emptyBarColor || '#eeeeee',
      'border-color': this.emptyBarColor || '#eeeeee'
    };
    const kendoProgressBar = kendo
      .jQuery(this.progressBar.nativeElement)
      .kendoProgressBar({
        chunkCount: this.chunkCount,
        min: this.min,
        max: this.max,
        value: this.value || 0,
        type: this.type,
        animation: {
          duration: 600
        }
      })
      .data('kendoProgressBar');
    kendoProgressBar.progressStatus.text(this.textBar || '');
    // kendoProgressBar.progressWrapper.css(this.progressBarStyle);
    kendoProgressBar.progressWrapper.addClass('primary-background');
  }
}
